import i18next from "i18next";
import { lazy } from "react";

import { getHiddenRoute } from "util/react";

import EN from "./i18n/en.json";

i18next.addResourceBundle("en", "GlassDeduction", EN);

export const URIS = {
  LIST: "/glass-deduction",
  EDIT: "/glass-deduction/:id",
  NEW: "/glass-deduction/new",
};

export const GlassDeductionListRoute = getHiddenRoute(
  "GlassDeduction",
  "menu.main",
  URIS.LIST,
  lazy(() => import("./layout/GlassDeductionListLayout")),
  null,
  ["admin"],
);
export const GlassDeductionCreateRoute = getHiddenRoute(
  "GlassDeduction",
  "menu.main",
  URIS.NEW,
  lazy(() => import("./layout/GlassDeductionEditLayout")),
  null,
  ["admin"],
);
export const GlassDeductionEditRoute = getHiddenRoute(
  "GlassDeduction",
  "menu.main",
  URIS.EDIT,
  lazy(() => import("./layout/GlassDeductionEditLayout")),
  null,
  ["admin"],
);

const GlassDeductionRoute = (
  <>
    {GlassDeductionListRoute}
    {GlassDeductionCreateRoute}
    {GlassDeductionEditRoute}
  </>
);

export default GlassDeductionRoute;
